import { gql } from '@apollo/client';
import { SharedFolder, FolderType } from 'types';
import { SHARED_FOLDER_FRAGMENT } from './FolderFragments';

export const CREATE_FOLDER_MUTATION = gql`
  mutation CreateFolder($createFolderInput: CreateFolderInput!) {
    createFolder(createFolderInput: $createFolderInput) {
      errorReason
      folder {
        ...SharedFolder
      }
    }
  }
  ${SHARED_FOLDER_FRAGMENT}
`;

export enum CreateFolderError {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED', // TODO : missing in backend
  DUPLICATE_FOLDERNAME = 'DUPLICATE_FOLDERNAME',
  NOT_LINKED = 'NOT_LINKED',
  WRONG_LINK = 'WRONG_LINK',
}

export type CreateFolderVariables = {
  createFolderInput: {
    channel?: string;
    folderName: string;
    folderType: FolderType;
    otherWebUserIds: string[];
  }
}

export type CreateFolderOutput = {
  createFolder: {
    errorReason: CreateFolderError;
    folder: SharedFolder;
  };
};

export const UPDATE_FOLDER_MUTATION = gql`
  mutation UpdateFolder($updateFolderInput: UpdateFolderInput!) {
    updateFolder(updateFolderInput: $updateFolderInput) {
      errorReason
      folder {
        ...SharedFolder
      }
    }
  }
  ${SHARED_FOLDER_FRAGMENT}
`;

export enum UpdateFolderError {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED', // TODO : missing in backend
  DUPLICATE_FOLDERNAME = 'DUPLICATE_FOLDERNAME',
  NOT_LINKED = 'NOT_LINKED',
  WRONG_LINK = 'WRONG_LINK',
}

export type UpdateFolderOutput = {
  updateFolder: {
    errorReason: UpdateFolderError;
    folder: SharedFolder;
  };
};

export const DELETE_FOLDER_MUTATION = gql`
  mutation DeleteFolder($deleteFolderInput: DeleteFolderInput!) {
    deleteFolder(deleteFolderInput: $deleteFolderInput) {
      errorReason
      isDeleted
    }
  }
`;

export enum DeleteFolderError {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT', // TODO : why not NOT_FOUND ?
  NOT_A_FOLDER = 'NOT_A_FOLDER',
  NOT_LINKED = 'NOT_LINKED',
  WRONG_LINK = 'WRONG_LINK',
}

export type DeleteFolderOutput = {
  deleteFolder: {
    errorReason: DeleteFolderError;
    isDeleted: boolean;
  };
};

export const SELF_UNSUBSCRIBE_MUTATION = gql`
  mutation SelfUnsubscribeMutation(
    $selfUnsubscribeInput: SelfUnsubscribeInput!
  ) {
    selfUnsubscribe(selfUnsubscribeInput: $selfUnsubscribeInput) {
      errorReason
      folder {
        ...SharedFolder
      }
    }
  }
  ${SHARED_FOLDER_FRAGMENT}
`;

export enum SelfUnsubscribeError {
  NOT_A_FOLDER = 'NOT_A_FOLDER',
  NOT_LINKED = 'NOT_LINKED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type SelfUnsubscribeMutationOutput = {
  selfUnsubscribe: {
    errorReason: SelfUnsubscribeError;
    folder: SharedFolder;
  };
};

export const SHARE_FOLDER_MUTATION = gql`
  mutation ShareFolderMutation($shareFolderInput: ShareFolderInput!) {
    shareFolder(shareFolderInput: $shareFolderInput) {
      errorReason
      folder {
        ...SharedFolder
      }
    }
  }
  ${SHARED_FOLDER_FRAGMENT}
`;

export enum ShareFolderError {
  NOT_A_FOLDER = 'NOT_A_FOLDER',
  NOT_LINKED = 'NOT_LINKED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAUTHORIZED_OTHER_USERS = 'UNAUTHORIZED_OTHER_USERS',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type ShareFolderMutationOutput = {
  shareFolder: {
    errorReason: ShareFolderError;
    folder: SharedFolder;
  };
};

export const UNSHARE_FOLDER_MUTATION = gql`
  mutation UnshareFolderMutation($unshareFolderInput: UnshareFolderInput!) {
    unshareFolder(unshareFolderInput: $unshareFolderInput) {
      errorReason
      folder {
        ...SharedFolder
      }
    }
  }
  ${SHARED_FOLDER_FRAGMENT}
`;

export enum UnshareFolderError {
  NOT_A_FOLDER = 'NOT_A_FOLDER',
  NOT_LINKED = 'NOT_LINKED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAUTHORIZED_OTHER_USERS = 'UNAUTHORIZED_OTHER_USERS',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type UnshareFolderMutationOutput = {
  unshareFolder: {
    errorReason: UnshareFolderError;
    folder: SharedFolder;
  };
};
